import { SemanticUI } from '@iterable/deprecated_react_components';
import { StyledFormField } from './styles';
import { EXACTLY, NOW, STARTOF } from './unitModifierOptions';

// type Props = {
//   /** Additional class name. */
//   className: string,
//   /** Label of the unit modifier dropdown. */
//   label: string,
//   /** Callback function when value of dropdown changes. */
//   onChange: ({}, { value: string }) => void,
//   /** If the now option should be visible. */
//   showNow: boolean,
//   /** The value of the unit modifier dropdown. */
//   value: string,
// };

const defaultProps = {
  label: 'Unit Modifier',
  showNow: true,
};

const UnitModifierDropdown = (props) => {
  const { className, label, onChange, showNow, value, ...otherProps } = props;
  const nowOption = showNow ? [NOW] : [];
  const options = [EXACTLY, STARTOF, ...nowOption];

  return (
    <StyledFormField className={className} labelText={label} {...otherProps}>
      <SemanticUI.Dropdown
        onChange={onChange}
        options={options}
        selection
        value={value || EXACTLY.value}
      />
    </StyledFormField>
  );
};

export default UnitModifierDropdown;
UnitModifierDropdown.defaultProps = defaultProps;
